import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Box,
  IconButton
} from "@mui/material";
import {DealsPageContext} from "../index";
import React, { useCallback, useContext, useEffect, useMemo } from "react";
import {DealsTableRows} from "./tableRows";
import {DealsPagination} from "./pagination";
import {useDeals} from "../useDeals";
import {Title5} from "../../../domains/common/components/Typography";
export const DealsTable = () => {
  const theme = useTheme();
  const {dealsList} = useContext(DealsPageContext);
  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '600px', // Минимальная высота
    }}>
    
      {dealsList.length < 1 ? <Title5 sx={{color: theme.palette.text.primary}} title="Ничего не найдено"/> 
      : 
      (<TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow  sx={{borderBottomColor: theme.palette.border.default}}>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Номер сделки</TableCell>
          <TableCell item sx={{borderBottomColor:'inherit'}}></TableCell>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Дата создания</TableCell>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Название</TableCell>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Тип сделки</TableCell>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Ответственный</TableCell>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Информация от РР</TableCell>
          <TableCell item sx={{color: theme.palette.text.tableHead.default, borderBottomColor:'inherit'}}>Статус</TableCell>
          <TableCell item sx={{borderBottomColor:'inherit'}}></TableCell>
          <TableCell item sx={{borderBottomColor:'inherit'}}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <DealsTableRows />
      </TableBody>
      </Table>
    </TableContainer> 
    
    )}
      <DealsPagination />
   
  </Box>
  )
}